// This function allow to reference async chunks
__webpack_require__.miniCssF = (chunkId) => ("static/css/" + chunkId + "." + {"260":"a1056aaf","420":"706395b0","631":"2e6ab283"}[chunkId] + ".chunk.css");